import { theme, type ThemeConfig } from 'antd'

const darkTheme: ThemeConfig = {
  algorithm: theme.darkAlgorithm,
  token: {
    colorPrimary: '#1677ff',
    colorBgContainer: '#141621',
    colorBgElevated: '#111322',
    colorBgLayout: '#0e101a',
    colorBgBase: '#0e101a',
    borderRadius: 6,
  },
  components: {
    Layout: {
      siderBg: '#111322',
      headerBg: '#0e101a',
      bodyBg: '#0e101a',
    },
    Menu: {
      darkItemBg: '#111322',
      darkSubMenuItemBg: '#111322',
    },
    Table: {
      headerBg: '#141621',
      rowHoverBg: '#1a1d2e',
    },
    Card: {
      colorBgContainer: '#141621',
    },
  },
}

const lightTheme: ThemeConfig = {
  algorithm: theme.defaultAlgorithm,
  token: {
    colorPrimary: '#1677ff',
    borderRadius: 6,
  },
}

export function getThemeConfig(mode: 'light' | 'dark'): ThemeConfig {
  return mode === 'dark' ? darkTheme : lightTheme
}
